import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "../../components/landing/landing.css";
import { LandingCtx } from "../../components/landing/ui";
import { Header, MobileBar } from "../../components/landing/Hero";
import { Hero } from "../../components/landing/LandingHero";
import { Pain, Solution } from "../../components/landing/SectionsA";
import { Jessy, Services, Automation, HowItWorks, Differentials, PriceSection, LeadSection } from "../../components/landing/SectionsD";
import { Traceability, Ledger, Portal, Control, ForWho, BeforeAfter, Security } from "../../components/landing/SectionsB";
import { Testimonials, Faq, FinalCta, Footer, FAQ } from "../../components/landing/SectionsC";
import { LeadDialog } from "../../components/landing/LeadDialog";
import { PartnerPopup } from "../../components/landing/PartnerPopup";
import { pickVariant, captureUtm, initTracking, track } from "../../lib/landing";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    { "@type": "ProfessionalService", name: "DPdigi", description: "Departamento Pessoal completo por assinatura mensal: plataforma digital, Inteligência Artificial (Jessy AI), processos automatizados, equipe especializada e processamento da folha de pagamento.", areaServed: "BR", priceRange: "Planos a partir de R$ 197/mês" },
    { "@type": "FAQPage", mainEntity: FAQ.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })) },
  ],
};

export default function Landing() {
  const [cfg, setCfg] = useState({});
  const [variant, setVariant] = useState(null);
  const [lead, setLead] = useState(null);
  useEffect(() => {
    document.title = "DPdigi | Departamento Pessoal completo, digital e inteligente — planos a partir de R$ 197/mês";
    captureUtm();
    axios.get(`${API}/public/landing`).then((r) => { setCfg(r.data); setVariant(pickVariant(r.data.variants)); initTracking(r.data); }).catch(() => { setVariant((v) => v || "A"); initTracking({}); });
  }, []);
  const ctx = useMemo(() => ({
    cfg,
    openLead: (source, extra = {}) => { track("cta_click", { source }); setLead({ source, ...extra }); },
  }), [cfg]);
  return (
    <LandingCtx.Provider value={ctx}>
      <div className="lp-root bg-white text-[#0F172A] antialiased" data-testid="landing-page">
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(SCHEMA) }} />
        <Header />
        <main>
          <Hero variant={variant} />
          <Jessy /><Services /><Automation /><HowItWorks /><Differentials /><PriceSection /><LeadSection />
          <Pain /><Solution /><Traceability /><Ledger /><Portal /><Control /><ForWho /><BeforeAfter /><Security />
          <Testimonials /><Faq /><FinalCta />
        </main>
        <Footer />
        <MobileBar />
        <LeadDialog open={!!lead} onOpenChange={(o) => !o && setLead(null)} ctx={lead} />
        <PartnerPopup blocked={!!lead} />
      </div>
    </LandingCtx.Provider>);
}
